import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { DateSparcScore } from '../data/speaking-score';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-organization-data',
  templateUrl: './organization-data.component.html',
  styleUrls: ['./organization-data.component.scss']
})
export class OrganizationDataComponent extends BaseComponent implements OnInit {
  @Input() organizationId: number;

  currentOrgAverageSparc: number;
  orgAverageSparcHistory: DateSparcScore[];
  sparcDataLoaded: boolean = false;
  orgAvgIncreased: boolean = false;
  orgAvgDecreased: boolean = false;
  chart: Chart;
  chartInitialized: boolean = false;
  showSPARCData: boolean = true;
  @ViewChild('speakingScoreChart') chartElement!: ElementRef<HTMLCanvasElement>;

  ngOnInit() {
    this.dataService.getOrganizationSpeakingScoreHistory(this.organizationId).subscribe(s => this.getOrgAverageScoreHistory(s));  
  }

  ngAfterViewChecked() {
    this.showChart();
  }

  getOrgAverageScoreHistory(scores: DateSparcScore[]): void {
    if (scores !== undefined && scores.length > 0) {
      this.orgAverageSparcHistory = scores.filter(x => !Number.isNaN(x.AvgScore) && x.AvgScore !== undefined && x.AvgScore !== null);
      
      if (this.orgAverageSparcHistory && this.orgAverageSparcHistory.length > 0) {
        this.currentOrgAverageSparc = this.orgAverageSparcHistory[this.orgAverageSparcHistory.length - 1].AvgScore;
        this.displaySpeakingScoreArrow();
        this.showChart();
      } else {
        this.showSPARCData = false;
      }
    } else {
      this.showSPARCData = false;
    }
    this.sparcDataLoaded = true;
  }

  displaySpeakingScoreArrow(): void {
    if (this.currentOrgAverageSparc && this.orgAverageSparcHistory && this.orgAverageSparcHistory.length > 1) {
      // the last element of the array is the current score, so we want to get the one before that
      var lastScore = this.orgAverageSparcHistory[this.orgAverageSparcHistory.length - 2]
      if (lastScore.AvgScore < this.currentOrgAverageSparc) {
        this.orgAvgIncreased = true;
      }
      else if (lastScore.AvgScore > this.currentOrgAverageSparc) {
        this.orgAvgDecreased = true;
      }
      // otherwise leave both as false and don't display an icon
    }
  }

  showChart() {
    if (this.chartInitialized || !this.chartElement || !this.orgAverageSparcHistory || !this.orgAverageSparcHistory.length || this.orgAverageSparcHistory.length == 0) return;

    var dateArray: Array<Date> = this.orgAverageSparcHistory.map(score => new Date(score.CalculationDate));

    // fill in the months that don't have data
    while (dateArray.length > 0 && dateArray.length < 12) {
      const lastDate = dateArray[dateArray.length - 1];
      const lastYear = lastDate.getFullYear();
      const lastMonth = lastDate.getMonth();
      // we can just use the first of the months that we don't have any data for
      const nextDate = lastMonth === 12 ? new Date(lastYear + 1, 1, 1) : new Date(lastYear, lastMonth + 1, 1);
      dateArray.push(nextDate);
    }

    var averageScoresArray: Array<number> = this.orgAverageSparcHistory.map(score => score.AvgScore);

    const minAvgScore = Math.min.apply(Math, averageScoresArray);
    const maxAvgScore = Math.max.apply(Math, averageScoresArray);

    // adjust scale based on the difference between min and max scores
    const yAxisStep = (maxAvgScore - minAvgScore > 100) ? 100 : 50;

    const yAxisMin = Math.floor(minAvgScore / yAxisStep) * yAxisStep;
    const yAxisMax = Math.ceil(maxAvgScore / yAxisStep) * yAxisStep;

    this.chart = new Chart(this.chartElement.nativeElement, {
      type: 'line',
      data: {
        labels: dateArray.map(date => date.toLocaleDateString('default', { month: 'short' })),
        datasets: [
          {
            label: 'Score',
            data: averageScoresArray,
            borderColor: '#03B1F2',
            backgroundColor: '#03B1F2',
            borderWidth: 1,
            pointRadius: 2,
            order: 1
          },
        ],
      },
      options: {
        aspectRatio: 4.75,
        plugins: {
          title: {
            display: false
          },
          legend: {
            display: false
          },
          tooltip: {
            backgroundColor: 'white',
            borderColor: (tooltipItem) => {
              return '#03b1f2'
            },
            borderWidth: 1,
            caretPadding: 10,
            bodyAlign: 'center',
            bodyFont: {
              family: 'Lato',
              size: 16,
              weight: 600
            },
            bodyColor: '#212529',
            footerAlign: 'center',
            footerFont: {
              family: 'Lato',
              size: 12,
              weight: 200
            },
            footerColor: '#212529',
            footerMarginTop: 2,
            displayColors: false,
            padding: 6,
            callbacks: {
              title: function (_) { return ''; },
              label: function (context) {
                return context.formattedValue;
              },
              footer: function (_) { return ''; }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              font: {
                family: 'Lato',
                size: 10
              },
              minRotation: 0,
              maxRotation: 0
            }
          },
          y: {
            min: yAxisMin,
            max: yAxisMax,
            ticks: {
              font: {
                family: 'Lato',
                size: 10
              }
            }
          }
        },
      },
    });
    this.chartInitialized = true;
  }
}
